import { useRef } from "react";
import { useMemoizedFn, useUpdate } from "ahooks";
/**
 * 用于受控组件中value的更新（输入组件）
 * @param options
 */
export function usePropsValue(options) {
  var value = options.value,
    defaultValue = options.defaultValue,
    onChange = options.onChange;
  var update = useUpdate();
  var stateRef = useRef(value !== undefined ? defaultValue : defaultValue);
  if (value !== undefined) {
    stateRef.current = value;
  }
  var setState = useMemoizedFn(function (v) {
    var forceTrigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var nextValue = typeof v === "function" ? v(stateRef.current) : v;
    if (!forceTrigger && nextValue === stateRef.current) return;
    stateRef.current = nextValue;
    update();
    return onChange === null || onChange === void 0 ? void 0 : onChange(nextValue);
  });
  return [stateRef.current, setState];
}